<template>
    <div>
        <app-new-breadcrumb></app-new-breadcrumb>
        <div class="container-news" >
            <h2 class="news-title">{{ $t("infographics") }}</h2>
            <div class="item-list">
                <div v-for="item in paginatedInfographics" :key="item.id" class="news-article">
                    <app-infographic-card :id="item.id"></app-infographic-card>
                </div>
            </div>
            <div class="col-md-12 text-center">
                <!-- <p class="d-block small text-muted">{{ $t('paginationInfo', getPaginationInfo) }}</p> -->
                <app-paginate class="d-inline-flex mt-3" v-model="searchObject.currentPage"
                    v-bind:page-count="searchObject.numberOfPages" v-bind:click-handler="changePage"
                    v-bind:prev-text="$t('previous')" v-bind:next-text="$t('next')"
                    v-bind:container-class="'pagination'" v-bind:page-class="'page-item'"
                    v-bind:page-link-class="'page-link small'" v-bind:next-class="'page-item'"
                    v-bind:next-link-class="'page-link small'" v-bind:prev-class="'page-item'"
                    v-bind:prev-link-class="'page-link small'" v-bind:page-range="3" v-bind:margin-pages="1">
                </app-paginate>

            </div>
        </div>
    </div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import InfographicCard from './InfographicCard.vue'
import Paginate from 'vuejs-paginate'
import Breadcrumb from "../../common/Breadcrumb.vue";

export default {
    data() {
        return {
            htmlContent: "",
            allNews: [],
            searchObject: {
                currentPage: 1,
                pageSize: 4,
                numberOfPages: 1,
                totalRecords: 0
            },
        }
    },
    props: ["id"],
    computed: {
        ...mapGetters(["getAllInfographics", "getContentById", "getContentByUrl"]),
        hasHiglightedNews() {
            return this.getAllInfographics.length > 0;
        },
        getPaginationInfo() {
            var start = ((this.searchObject.currentPage - 1) * this.searchObject.pageSize) + 1;
            var end = Math.min(start + this.searchObject.pageSize - 1, this.searchObject.totalRecords);

            return [start, end, this.searchObject.totalRecords];
        },
        paginatedInfographics() {
            const startIndex = (this.searchObject.currentPage - 1) * this.searchObject.pageSize;
            const endIndex = startIndex + this.searchObject.pageSize;

            return this.getAllInfographics.slice(startIndex, endIndex);
        },
      
    },
    components: {
        appInfographicCard: InfographicCard,
        appPaginate: Paginate,
        appNewBreadcrumb: Breadcrumb
    },
    methods: {
        ...mapActions(["fetchContentById"]),
        changePage(page) {
            this.searchObject.currentPage = page;
            this.updatePaginationInfo();
        },
        updatePaginationInfo() {
            const totalRecords = this.getAllInfographics.length;
            this.searchObject.totalRecords = totalRecords;
            this.searchObject.numberOfPages = Math.ceil(totalRecords / this.searchObject.pageSize);
        }
    },
    created() {
        this.updatePaginationInfo();
    },
}
</script>

<style scoped>
.news {
    background-color:  var(--secondary-color);
    padding: 5% 7% 2% 7%;
}

.news-title {
    color: var(--main-color);
    margin-bottom: 2%;
    font-size: 30px;
    text-decoration: none;
    font-weight: 600;
}

.news-title a {
    text-decoration: none;
    color: var(--main-color);
}

.news-title a:hover {
    text-decoration: none;
}

.news-article {
    border-radius: 15px;
    background-color:  var(--secondary-color);
    padding: 15px;
    width: calc((100% - 30px)/4);
    min-width: calc((100% - 30px)/4);
}

.container-news {
    width: 100%;
    padding: 10px 7% 2% 7%;
    display: block;
    justify-content: center;
    align-items: center;
    background-color: var(--light-color);
}

.item-list {
    width: 100%;
    display: flex;
    gap: 10px;
    overflow: hidden;
}


@media only screen and (max-width: 1200px) {   
.item-list {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    
}

.news-article {
    width: 100%;
    min-width: 100%;
}
}

@media only screen and (max-width: 768px) {
    .item-list {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    
}
}

</style>
